import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from './components/components.module';
import { ConfigModule } from '@spartacus/core';
import { CustomThankMessageComponent } from './components/custom-thank-message/custom-thank-message.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ComponentsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        OrderConfirmationThankMessageComponent: {
          component: CustomThankMessageComponent,
        },
      },
    }),
  ],
})
export class CustomOrderConfirmationModule {}
